module.exports = __webpack_public_path__ + "img/edit2.e2422c51.svg";